import type { AgencyModel, CampaignModel } from '@models/types'

import PageContent from './components/PageContent'

type OverviewProps = {
  agency: AgencyModel,
  campaign: CampaignModel,
}

const Overview = (props: OverviewProps) => (
  <PageContent {...props} />
)

export default Overview
